import React from 'react';
import styles from './PaymentOptions.module.css';

const PaymentOptions = () => {
  const paymentMethods = [
    {
      id: 1,
      title: 'Insurance Coverage',
      description: 'We verify coverage upon receipt of an Assignment of Benefits and bill your insurance carrier directly whenever possible.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM20 20H4V8H20V20Z" fill="currentColor"/>
          <path d="M12 12C10.9 12 10 12.9 10 14C10 15.1 10.9 16 12 16C13.1 16 14 15.1 14 14C14 12.9 13.1 12 12 12Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Medicare',
      description: 'If you qualify for Medicare-covered home health services, our office will handle billing directly with Medicare.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
          <path d="M13 17H11V13H7V11H11V7H13V11H17V13H13V17Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Direct Payment',
      description: 'When services are billed directly to you: Statements clearly show visits and hours worked. You pay only the per-visit or per-hour rate. We cover all taxes, insurance, and employment costs for our caregivers.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 18V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.9 6 10 6.9 10 8V16C10 17.1 10.9 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z" fill="currentColor"/>
        </svg>
      )
    }
  ];

  return (
    <section className={styles.paymentSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.tag}>WHO PAYS FOR CARE SERVICES?</p>
          <h2 className={styles.heading}>Coverage & Payment Options</h2>
        </div>

        <div className={styles.cardsGrid}>
          {paymentMethods.map((method) => (
            <div key={method.id} className={styles.card}>
              <div className={styles.cardIcon}>{method.icon}</div>
              <h3 className={styles.cardTitle}>{method.title}</h3>
              <p className={styles.cardDescription}>{method.description}</p>
            </div>
          ))}
        </div>

        {/* <div className={styles.footer}>
          <p className={styles.footerText}>Transparent billing. No hidden fees.</p>
        </div> */}
      </div>
    </section>
  );
};

export default PaymentOptions;
